import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

const reportWebVitals = async (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    try {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
      console.log('Web Vitals metrics collection initialized');
    } catch (error) {
      console.warn('Error collecting web-vitals metrics:', error);
    }
  }
};

export default reportWebVitals;
